<template>
    <div class="generic-page-wrapper">
        <div class="generic-page-loader spinner" v-if="isLoading">
            <div class="new_prelader"></div>
        </div>
        <div v-else class="generic-page-content ck-content" v-html="pageContent">
        </div>
    </div>
</template>

<script>

export default {
    name: 'GenericPage',
    props: {
        value: {
            type: Object,
            default: () => {
                return {} //container-fluid
            },
        },
        className: {
            type: String,
            default: 'responsive-page',
        },
        showLoading: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
        };
    },
    mounted() {

    },
    computed: {
        isLoading() {
            return this.showLoading && !this.pageContent;
        },
        pageContent() {
            return this.value?.content ?? '';
        }
    },
    methods: {

    },
    watch: {
        src() {

        }
    },
};
</script>

<style scoped lang="scss">
@import "@styles/_mixins.scss";
.generic-page-wrapper {
    @include flexbox;
    @include flex-direction(column);
    height: 100%;

    .generic-page-loader {
        margin: 0;
        margin-top: -16px; //padding do top
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: auto;
        height: auto;
    }

    .generic-page-content {
        position: relative;
        @include flex-grow(1);
        // padding-top: 15px;
        width: 100%;
        overflow: auto;
    }
}
</style>

<style lang="scss">
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";
.generic-page-content {
    &.ck-content {
        .raw-html-embed {
            .full-screen {
                height: calc(#{$navbar-sidebar-height} - 32px - 48px); // 32px (16+16 de padding) + 48px do sidebar
                @include md {
                    height: calc(#{$navbar-sidebar-height-sm} - 32px);
                }
            }
        }
    }
}
</style>
